window.addEventListener("load", (event) => {
    const isVaildURL = require('is-url-http/lightweight')
    const properties = new Map();

    properties.set("brookedotbike", { title: "Brooke.bike", url: "https://brooke.bike", tagline: "A log of bicycle travel." });
    properties.set("brookedotblog", { title: "Brooke.blog", url: "https://brooke.blog", tagline: "A blog of personal musings." });
    properties.set("brookedotcodes", { title: "Brooke.codes", url: "https://brooke.codes", tagline: "A technical journal for the modern era." });
    properties.set("brookedotis", { title: "Brooke.is", url: "https://brooke.is", tagline: "A delightful attempt at an explanation. " });
    properties.set("brookedotphoto", { title: "Brooke.photo", url: "https://brooke.photo", tagline: "A photo a day, sometimes." });

    /* 
     * Loop through the "property" class and handle click acctions 
     */
    var propClass = document.getElementsByClassName('property');

    for (var i = 0; i < propClass.length; i++) {
        propClass[i].addEventListener("click",
            function (e) {
                e.preventDefault();
                removeProperty();
                // get the data property value
                let propertyKey = this.dataset.property;

                // ensure the value is in the properties array map 
                if (properties.has(propertyKey)) {
                    let property = properties.get(propertyKey);

                    // add the current key as body class
                    document.body.classList.add(propertyKey);

                    // update title
                    if ('title' in property) {
                        let title = document.getElementById("property")
                        title.innerHTML = property['title'];

                        // add large icon
                        let icon = document.createElement('p');
                        icon.innerHTML = '<i class="icon icon-' + propertyKey + '"></i>';
                        icon.classList = 'is-hidden-mobile';
                        icon.id = 'icon-large'

                        title.parentNode.insertBefore(icon, title);
                    }
                    // update tagline
                    if ('tagline' in property) {
                        let tagline = document.getElementById("tagline");
                        tagline.innerHTML = property['tagline'];

                        // validate and add the site URL Button
                        if ('url' in property && isVaildURL(property['url'])) {
                            let button = document.createElement('p');
                            button.innerHTML = '<a href = "' + property['url'] + '"><button class="button ">Visit Site</button></a>';
                            button.classList = 'subtitle my-4';
                            button.id = 'url';

                            tagline.parentNode.insertBefore(button, tagline.nextSibling);
                        }
                    }
                }
            },
            false);
    }

    /* 
     * Contact Link in top nav
     */
    document.querySelector(".contact").addEventListener("click", (e) => {
        e.preventDefault();
        removeProperty();
        document.getElementById("property").innerHTML = "Contact Brooke.";
        document.getElementById("tagline").innerHTML = "hi[at]broo.ke";
        document.body.classList.add('contact');
    });

    /* 
     * Helper function to remove all body classes and added elements (icon & link button)
     */
    function removeProperty() {
        const removeURL = document.getElementById('url');
        const removeIcon = document.getElementById('icon-large');

        if (removeURL) {
            removeURL.remove();
        }
        if (removeIcon) {
            removeIcon.remove();
        }

        // remove each properties map value from the body class
        properties.forEach((value, key) => {
            document.body.classList.remove(key);
        })
        document.body.classList.remove('contact');
    }
    /* 
     * Dark Mode Toggle 
     * https://dev.to/whitep4nth3r/the-best-lightdark-mode-theme-toggle-in-javascript-368f
     */
    function isThemeSet({ localStorageTheme, systemSettingDark }) {
        if (localStorageTheme !== null) {
            return localStorageTheme;
        }

        if (systemSettingDark.matches) {
            return "dark";
        }
        return "light";
    }

    const localStorageTheme = localStorage.getItem("theme");
    const systemSettingDark = window.matchMedia("(prefers-color-scheme: dark)");
    const darkmodeToggle = document.querySelector(".theme-toggle");
    const toggleClass = "theme-toggle--toggled";

    let currentThemeSetting = isThemeSet({ localStorageTheme, systemSettingDark });

    if (currentThemeSetting === "dark") {
        darkmodeToggle.classList.add(toggleClass);
        darkmodeToggle.setAttribute("aria-label", "Change to light theme");
        darkmodeToggle.setAttribute("title", "Change to light theme");
        document.querySelector("html").setAttribute("data-theme", "dark");
    }

    darkmodeToggle.addEventListener("click", (e) => {
        e.preventDefault();
        const setTheme = currentThemeSetting === "dark" ? "light" : "dark";
        const ariaText = setTheme === "dark" ? "Change to light theme" : "Change to dark theme";

        darkmodeToggle.classList.toggle(toggleClass);
        darkmodeToggle.setAttribute("aria-label", ariaText);
        darkmodeToggle.setAttribute("title", ariaText);

        document.querySelector("html").setAttribute("data-theme", setTheme);

        localStorage.setItem("theme", setTheme);
        currentThemeSetting = setTheme;
    });

});